/**
 * Grupos de endpoints por função para o modal de permissões de Grupos.
 * Cada grupo contém padrões (substrings) do path do endpoint.
 * Ao clicar no grupo, todos os endpoints cujo path contém algum padrão são adicionados.
 */
export default [
	{ label: 'Saídas', patterns: ['/outputs', '/output-orders'] },
	{ label: 'Entradas', patterns: ['/inputs', '/input-orders'] },
	{ label: 'Estoques', patterns: ['/stocks'] },
	{ label: 'Pedidos de Entrada', patterns: ['/input-orders', '/companies/input-orders', '/receipt-types'] },
	{ label: 'Pedidos de Saída', patterns: ['/output-orders'] },
	{ label: 'Catálogo', patterns: ['/products', '/packagings', '/categories', '/manufacturers', '/units', '/classes'] },
	{ label: 'Armazenamento', patterns: ['/warehouses', '/locations', '/lots', '/inventories', '/replenishments', '/devices'] },
	{ label: 'Comercial', patterns: ['/customers', '/payment-terms', '/price-lists', '/cfops', '/customer-prices'] },
	{ label: 'Faturamento', patterns: ['/invoices', '/invoice-lots'] },
	{ label: 'Organização', patterns: ['/suppliers', '/carriers'] },
	{ label: 'Sistema', patterns: ['/groups', '/users', '/companies', '/endpoints', '/states', '/cities', '/logs', '/version', '/import-center', '/integration-events'] },
	{ label: 'Transações', patterns: ['/transactions'] },
];
